import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import {
    Row,
    Col,
    Table,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    UncontrolledTooltip,
} from "reactstrap";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import FormViandas from "./FormViandas.js";
import "./ModalConfirmacion.scss";

class ModalConfirmacion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenDetalle: false,

            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(["CREATE", "EDIT", "DETAIL", "DELETE"]).isRequired,
        lugaresEntregaSelect: PropTypes.array.isRequired,
        lugarEntrega: PropTypes.number.isRequired,
        otros_lugar_entrega: PropTypes.string,
        // Se usan los ar_ para recuperar los nombres de cada objeto,
        // esto es porque pedidosViandaDetalle solo tiene los id de los
        // objetos elegidos.
        opcionNadaId: PropTypes.number.isRequired,
        pedidosViandaDetalle: PropTypes.array.isRequired,
        centrosCostoSelect: PropTypes.array.isRequired,
        ar_entradas: PropTypes.array.isRequired,
        ar_menusPrincipales: PropTypes.array.isRequired,
        ar_guarniciones: PropTypes.array.isRequired,
        ar_ensaladas: PropTypes.array.isRequired,
        ar_complementos: PropTypes.array.isRequired,
        ar_postres: PropTypes.array.isRequired,
        ar_bebidas: PropTypes.array.isRequired,
    };

    resetForm() {
        this.setState({
            errors: [],
        });
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState((prevState) => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
            else return null;
    }

    changeIsOpen = () => {
        const { isOpenDetalle } = this.state;

        if (isOpenDetalle == true) {
            this.resetForm();
            this.setState({ isOpenDetalle: !isOpenDetalle });
        } else {
            this.setState({ isOpenDetalle: !isOpenDetalle });
        }
    };

    onValidate = () => {
        const {} = this.state;

        let errors = {};
        let valid = true;

        this.setState({ errors: errors });

        return valid;
    };

    onSubmit = () => {
        this.setState({ isOpenDetalle: false });
        this.props.onSubmit();
    };

    /**
     * Se usa para recuperar los nombres de las comidas, personas o
     * lugares de entrega a partir de su lista de Ids seleccionados y
     * su lista completa con mas informacion.
     */
    getNombresObjetosSeleccionados = (objetosSeleccionadosId, objetos) => {
        const { opcionNadaId } = this.props;
        const nombresSeleccionados = [];

        objetosSeleccionadosId.forEach(objetoId => {
            const objeto = objetos.find(objeto => 
                (objeto.id === objetoId) &&
                    //Para que no muestre el nombre de la opciona 'Nada'
                    (objeto.id !== opcionNadaId)
            );

            if (objeto) {
                nombresSeleccionados.push(objeto.nombre);
            }
        });

        return nombresSeleccionados.join(', ');
    }

    getCentroCostoCodigo = (centroCostoID) => {
        const { centrosCostoSelect } = this.props
        const centroCosto = centrosCostoSelect.find(centroCosto => centroCosto.id === centroCostoID)

        return centroCosto.codigo
    }

    render() {
        const { isOpenDetalle } = this.state;
        const {
            disabled,
            title,
            pedidosViandasDetalle,
            ar_entradas,
            ar_menusPrincipales,
            ar_guarniciones,
            ar_ensaladas,
            ar_complementos,
            ar_postres,
            ar_bebidas,
            observacion,
            lugarEntrega,
            lugar_entrega_otros,
            lugaresEntregaSelect,
            onValidation,
        } = this.props;

        return (
            <Fragment>
                <Button
                    className="px-5 rounded"
                    color="success"
                    disabled={disabled}
                    onClick={() =>
                        !disabled && onValidation() ? this.changeIsOpen() : null
                    }
                >
                    <i className="fa fa-check mr-1"></i>
                    Confirmar Pedido
                </Button>
                <Modal
                    isOpen={isOpenDetalle}
                    toggle={() => this.changeIsOpen()}
                    className={"modal-primary modal-xl"}
                >
                    <ModalHeader>{title}</ModalHeader>
                    <ModalBody>
                        <Row>
                            {/* Input lugarEntrega */}
                            <Col xs="4">
                                <ParadigmaLabeledInput
                                    md={[5, 7]}
                                    className="mr-2"
                                    label={"Lugar de entrega"}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            disabled
                                            optionDefault={lugaresEntregaSelect}
                                            value={lugarEntrega}
                                        />
                                    }
                                />
                            </Col>

                            {/* Input lugar_entrega_otros */}
                            {lugar_entrega_otros !== null && lugar_entrega_otros.trim() !== '' && (
                                <React.Fragment>
                                    <Col xs="6">
                                        <ParadigmaLabeledInput
                                            md={[3, 9]}
                                            disabled
                                            label={"Especificado"}
                                            value={lugar_entrega_otros}
                                        />
                                    </Col>
                                </React.Fragment>
                            )}

                            {/* Btn Ayuda Lugar Entrega */}
                            <Col className="col-1 d-flex align-items-center">
                                <Button
                                    id="lugarEntregaAyuda"
                                    size="sm"
                                    color="warning"
                                    className="rounded"
                                >
                                    <i className="fa fa-question" />
                                </Button>
                            </Col>

                            {/* Tooltip Ayuda */}
                            <UncontrolledTooltip
                                className="rounded-tooltip"
                                placement="right"
                                target="lugarEntregaAyuda"
                            >
                                El lugar de entrega es el mismo que fué completado anteriormente
                            </UncontrolledTooltip>

                            <Col className={"col-12"}>
                                <Table
                                    striped
                                    hover
                                    size="sm"
                                    className="mt-3 tvp"
                                >
                                    <thead>
                                        <tr>
                                            <th className="th-numero">
                                                N°
                                            </th>
                                            <th className="th-personas" >
                                                Persona
                                            </th>
                                            <th className="th-centros-costo" >
                                                Centro Costo
                                            </th>
                                            <th className="th-entradas" >
                                                Entrada
                                            </th>
                                            <th className="th-menus-principales" >
                                                Menú Principal
                                            </th>
                                            <th className="th-guarniciones" >
                                                Guarnicion
                                            </th>
                                            <th className="th-ensaladas" >
                                                Ensalada/s
                                            </th>
                                            <th className="th-complementos" >
                                                Complemento/s
                                            </th>
                                            <th className="th-postres" >
                                                Postre
                                            </th>
                                            <th className="th-bebidas" >
                                                Bebida
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pedidosViandasDetalle.length == 0 ? (
                                            <tr>
                                                <td className="text-center" colSpan={3}>
                                                    No hay pedidos agregados
                                                </td>
                                            </tr>
                                        ) : (
                                                pedidosViandasDetalle.map((detalle, i) => (
                                                    <tr key={i}>
                                                        <td className="td-numero">
                                                            {i + 1}
                                                        </td>
                                                        <td className="td-personas">
                                                            {detalle.apellido}
                                                        </td>
                                                        <td className="td-centros-costo">
                                                            {this.getCentroCostoCodigo(detalle.dependencia)}
                                                        </td>
                                                        <td className="td-entradas">
                                                            {this.getNombresObjetosSeleccionados([detalle.entrada], ar_entradas)}
                                                        </td>
                                                        <td className="td-menus-principales">
                                                            {this.getNombresObjetosSeleccionados([detalle.menu_principal], ar_menusPrincipales)}
                                                        </td>
                                                        <td className="td-guarniciones">
                                                            {this.getNombresObjetosSeleccionados([detalle.guarnicion], ar_guarniciones)}
                                                        </td>
                                                        <td className="td-ensaladas">
                                                            {this.getNombresObjetosSeleccionados(detalle.ensaladas, ar_ensaladas)}
                                                        </td>
                                                        <td className="td-complementos">
                                                            {this.getNombresObjetosSeleccionados(detalle.complementos, ar_complementos)}
                                                        </td>
                                                        <td className="td-postres">
                                                            {this.getNombresObjetosSeleccionados([detalle.postre], ar_postres)}
                                                        </td>
                                                        <td className="td-bebidas">
                                                            {this.getNombresObjetosSeleccionados([detalle.bebida], ar_bebidas)}
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                    </tbody>
                                </Table>
                            </Col>

                            <Col className={"col-12"}>
                                <ParadigmaLabeledInput
                                    type={"textarea"}
                                    maxLength={1000}
                                    label={"Observación"}
                                    value={observacion}
                                    onChange={(e) =>
                                        this.props.onChangeObservacion(e)
                                    }
                                    error={() => this.getError("observacion")}
                                />
                            </Col>
                        </Row>
                    </ModalBody>

                    {/* ----- Modal Footer ----- */}
                    <ModalFooter>
                        <Button
                            className="rounded"
                            color="success"
                            onClick={() => this.onSubmit()}>
                            Confirmar
                        </Button>
                        <Button
                            className="rounded"
                            color="secondary"
                            onClick={() => this.changeIsOpen()}
                        >
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

export default ModalConfirmacion;



// WEBPACK FOOTER //
// ./src/views/Viandas/PedidosViandas/ModalConfirmacion.js